"use client";
import { useSyncExternalStore } from "react";
import { useTheme } from "./theme_provider";
import styles from "./theme_toggle.module.css";
const subscribe = () => () => {};
const clientSnapshot = () => true;
const serverSnapshot = () => false;
/** テーマを切り替え、cookieに次回SSR用の値を保存する。cookie禁止時もUI操作は継続する。 */
export default function ThemeToggle() {
	const { resolvedTheme, setTheme } = useTheme();
	const mounted = useSyncExternalStore(subscribe, clientSnapshot, serverSnapshot);
	const dark = mounted && resolvedTheme === "dark";
	function toggle() {
		const next = dark ? "light" : "dark";
		setTheme(next);
		try {
			document.cookie = `theme=${next}; max-age=31536000; path=/`;
		} catch {
			/* cookie保存が禁止されても閲覧を妨げない。 */
		}
	}
	return (
		<button
			type="button"
			className={styles.toggle}
			onClick={toggle}
			disabled={!mounted}
			aria-label="テーマ切り替え"
			aria-pressed={dark}
		>
			<span aria-hidden="true">{dark ? "☀" : "☾"}</span>
		</button>
	);
}
